import { Directive, HostListener } from '@angular/core';
import { FormDataValidityBaseDirective } from './form-data-validity-base.directive';
import { CustomHostListeners } from '@lx/shared/utils';

@Directive({
  standalone: true,
  selector: '[lxFormDataCustomComponentValidity]',
  exportAs: 'lxFormDataCustomComponentValidity',
})
export class FormDataCustomComponentValidityDirective<T> extends FormDataValidityBaseDirective<T> {
  protected getNoFormDataWarningMessage(): string {
    return 'FormDataCustomComponentValidityDirective - Form data is not defined';
  }

  @HostListener(`${CustomHostListeners.componentFocusOut}`)
  onComponentFocusOut() {
    this.enabledValidation$.next(true);
  }
}
